import { allLayers, layerFilters } from "../../constants/constants";

const createLayerFilter = (layerName, featuresFilter) => {
    const mainFilter = ['all'];
    if (layerFilters[layerName]) {
        mainFilter.push(layerFilters[layerName]);
    }
    mainFilter.push(featuresFilter);
    return mainFilter;
}

export default function filterFeaturesOnMap(map, featureIds) {
    const featuresFilter = ['in', '$id', ...featureIds];
    for (const layer of allLayers) {
        map.setFilter(layer, createLayerFilter(layer, featuresFilter));
    }
}